import React from 'react';
import classnames from 'classnames';
import { FormGroup } from 'reactstrap';
import { Intl } from 'components';

const CheckboxInput = React.memo( ( {
  label, value, inputName, inputOnChange, onChange, formGroupClass, labelClass,
  labelStyle, translateValues, meta, isInvalid, formId = '', translateLabel = true, disabled = false, onElementClick, divStyle = {}
} ) => (
  <FormGroup className={classnames( formGroupClass, { 'is-invalid': isInvalid } )}>
    <div className="custom-control custom-checkbox custom-checkbox-white">
      <div onClick={onElementClick} style={{ width: 'fit-content',...divStyle }}>
        <input
          className="custom-control-input"
          checked={value}
          id={`${formId}-${inputName}`}
          type="checkbox"
          disabled={disabled}
          onChange={( e ) => {
            if ( inputOnChange ) inputOnChange( e.target.checked );
            if ( onChange ) onChange( e.target.checked );
          }}
        />

        <label
          className={classnames( 'custom-control-label', labelClass )}
          htmlFor={`${formId}-${inputName}`}
          style={labelStyle || {}}
        >
          {/* eslint-disable-next-line no-nested-ternary */}
          {label ? ( translateLabel ? <Intl id={label} /> : label ) : null}
        </label>
      </div>
    </div>

    {isInvalid
        && (
          <div className="invalid-feedback">
            <Intl id={meta.error || meta.submitError} values={translateValues} />
          </div>
        )}
  </FormGroup>
) );

export default CheckboxInput;
